module.exports = __webpack_public_path__ + "img/适老化1.3820d4ab.jpg";